/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, SyntheticEvent } from 'react';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from 'primereact/datatable';
import { Column, ColumnEditorOptions } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import BillOfMaterial from '../../models/BillOfMaterial';
import RawMaterialGroup from '../../models/RawMaterialGroup';
import MaterialUsage from '../../models/MaterialUsage';
import SetupOptionsColor from '../../models/SetupOptionsColor';
import SetupOptions from '../../models/SetupOptions';
import { Controller, useForm } from 'react-hook-form';
import { RawMaterialGroupService } from '../../service/RawMaterialGroupService';
import { MaterialUsageService } from '../../service/MaterialUsageService';
import { SetupOptionsService } from '../../service/SetupOptionsService';
import { BillOfMaterialService } from '../../service/BillOfMaterialService';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputNumber } from 'primereact/inputnumber';
import { Link, useParams } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { FilterMatchMode } from 'primereact/api';
import { Checkbox } from 'primereact/checkbox';

const StyleBillOfMaterials = () => {
    let emptyBillOfMaterial: BillOfMaterial = {
        id: 0,
        style_Code: '',
        sequence: undefined,
        setup_Prompt: 0,
        setup_Option: '',
        raw_Material_Group: undefined,
        rmgIsExcluded: false,
        usage_Code: undefined,
        setup_Prompt_For_Color: undefined,
        sublimation: false,
        qty: 0
    };

    const [billOfMaterials, setBillOfMaterials] = useState<BillOfMaterial[]>([]);
    const [rawMaterialGroups, setRawMaterialGroups] = useState<RawMaterialGroup[]>([]);
    const [materialUsages, setMaterialUsages] = useState<MaterialUsage[]>([]);
    const [setupOptionsColors, setSetupOptionsColors] = useState<SetupOptionsColor[]>([]);
    const [billOfMaterialsSetupOptions, setBillOfMaterialsSetupOptions] = useState<SetupOptions[]>([]);
    const [loadingStyleBillOfMaterials, setLoadingStyleBillOfMaterials] = useState(true);
    const [deleteBillOfMaterialDialog, setDeleteBillOfMaterialDialog] = useState(false);
    const [billOfMaterial, setBillOfMaterial] = useState<BillOfMaterial>(emptyBillOfMaterial);
    const [quantity, setQuantity] = useState<number | null | undefined>(0);
    const [rawMaterialGroupDescription, setRawMaterialGroupDescription] = useState<string | null | undefined>('');
    const [newRawMaterialGroupDescription, setNewRawMaterialGroupDescription] = useState<string | null | undefined>('');
    const [billOfMaterialSetupOptionDescription, setBillOfMaterialSetupOptionDescription] = useState<string | null | undefined>('');
    const [setupColorDescription, setSetupColorDescription] = useState<string | undefined>('');
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const [filters, setFilters] = useState<DataTableFilterMeta>({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [editingRows, setEditingRows] = useState({});

    const toast = useRef<any>(null);
    const isNew = useRef(false);
    const dtBom = useRef<any>(null);
    const ddSetupOption = useRef<Dropdown>(null);
    const ddUsageCode = useRef<Dropdown>(null);
    const ddDefaultColor = useRef<Dropdown>(null);
    const chkSublimation = useRef<any>(null);
    const { styleCode } = useParams();
    
    useEffect(() => {
        if (!styleCode) { return; }

        !loadingStyleBillOfMaterials && setLoadingStyleBillOfMaterials(true);

        BillOfMaterialService.getBillOfMaterialByStyleCode(styleCode).then(bom => {
            setBillOfMaterials(bom);
            setLoadingStyleBillOfMaterials(false);
        });

        RawMaterialGroupService.getRawMaterialGroups().then(data => setRawMaterialGroups(data));
        MaterialUsageService.getMaterialUsages().then(data => setMaterialUsages(data));
        SetupOptionsService.getSetupOptionsColors().then(data => setSetupOptionsColors(data));
        SetupOptionsService.getBillOfMaterialsSetupOptions().then(data => setBillOfMaterialsSetupOptions(data));
    }, []);

    useEffect(() => {
        if (billOfMaterial.usage_Code === 0 || billOfMaterial.usage_Code === undefined) {
            setQuantity(0);
            setRawMaterialGroupDescription('NA');
        } else {
            let _materialUsages = [...materialUsages];
            let _materialUsage = _materialUsages.find((v) => { return v.usage_Code === billOfMaterial.usage_Code });
            let _rawMaterialGroups = [...rawMaterialGroups];
            let _rawMaterialGroupDescription = _rawMaterialGroups.filter((v) => v.id === _materialUsage?.raw_Material_Group).map((val) => { return val.raw_Material_Group + ' - ' + val.description; })[0];
            setQuantity(_materialUsage?.usage);
            setRawMaterialGroupDescription(_rawMaterialGroupDescription);
        }
    }, [billOfMaterial.usage_Code]);

    const defaultValues: Record<string, any> = {
        setupOption: null,
        usageCode: null,
        colorSequenceReference: '',
        defaultColor: null
    };

    const {
        control: controlBillOfMaterials,
        formState: { errors: errorsBillOfMaterials },
        trigger: triggerBillOfMaterials,
        reset: resetBillOfMaterials,
        handleSubmit: handleSubmitBillOfMaterials } = useForm({ defaultValues });

    const formEditBillOfMaterials = useForm({ mode: "onChange" });
    
    const getBillOfMaterialsErrorMessage = (name: string) => {
        return errorsBillOfMaterials[name] ? <small className="p-error">{(errorsBillOfMaterials[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const getNewRawMaterialGroupDescription = (usageCode: number) => {
        let _materialUsages = [...materialUsages];
        let _materialUsage = _materialUsages.find((v) => { return v.usage_Code === usageCode });
        let _rawMaterialGroups = [...rawMaterialGroups];
        let _rawMaterialGroupDescription = usageCode === 0 || usageCode === undefined ? "NA" : _rawMaterialGroups.filter((v) => v.id === _materialUsage?.raw_Material_Group).map((val) => { return val.raw_Material_Group + ' - ' + val.description; })[0];
        setTimeout(() => setNewRawMaterialGroupDescription(_rawMaterialGroupDescription), 0);
    };

    const getBillOfMaterialSetupOptionDescription = (setupId: number) => {
        let _billOfMaterialsSetupOptions = [...billOfMaterialsSetupOptions];
        let _billOfMaterialsSetupOptionDescription = _billOfMaterialsSetupOptions.filter((v) => v.setupId === setupId).map((val) => { return val.setupDescription; })[0];
        setTimeout(() => setBillOfMaterialSetupOptionDescription(_billOfMaterialsSetupOptionDescription), 0);
    };

    const getSetupColorDescription = (colorCode: string) => {
        let _setupOptionsColors = [...setupOptionsColors];
        let _setupColorDescription = _setupOptionsColors.filter((v) => v.colorCode === colorCode).map((val) => { return val.description; })[0];
        setTimeout(() => setSetupColorDescription(_setupColorDescription), 0);
    };

    const getNextSequence = (arr: any, prop: string) => {
        var max;
        for (var i = 0; i < arr.length; i++) {
            if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop]))
                max = arr[i];
        }
        return max.sequence + 1;
    }

    const onSubmitBillOfMaterials = (data: any, e: any) => {
        isNew.current = true;
        let _billOfMaterial = { ...billOfMaterial };
        let _billOfMaterials = [...billOfMaterials];

        _billOfMaterial.sequence = _billOfMaterials.length === 0 ? 51 : getNextSequence(_billOfMaterials, 'sequence');
        _billOfMaterial.style_Code = styleCode;
        _billOfMaterial.setup_Prompt = data.setupOption;
        _billOfMaterial.usage_Code = data.usageCode !== null ? parseInt(data.usageCode, 10) : undefined;

        let _materialUsages = [...materialUsages];
        let _materialUsage = _materialUsages.find((v) => { return v.usage_Code === parseInt(data.usageCode, 10) });
        _billOfMaterial.raw_Material_Group = _materialUsage?.raw_Material_Group !== null ? _materialUsage?.raw_Material_Group : undefined;
        _billOfMaterial.setup_Prompt_For_Color = data.colorSequenceReference === '' ? 0 : parseInt(data.colorSequenceReference, 10);
        _billOfMaterial.default_Color = data.defaultColor;
        _billOfMaterial.sublimation = data.sublimation;
        saveBillOfMaterial(_billOfMaterial);
        resetBillOfMaterials(e);
    };

    const hideDeleteBillOfMaterialDialog = () => {
        setDeleteBillOfMaterialDialog(false);
    }

    const saveBillOfMaterial = (billOfMaterialData: BillOfMaterial) => {
        let _billOfMaterials = [...billOfMaterials];

        setSetupColorDescription(undefined);
        formEditBillOfMaterials.reset({ keepDirty: false, keepDirtyValues: false });

        if (isNew.current) {
            BillOfMaterialService.addBillOfMaterial(billOfMaterialData).then((data) => {
                let _billOfMaterialsSetupOptions = [...billOfMaterialsSetupOptions];
                let _billOfMaterialsSetupOptionDescription = _billOfMaterialsSetupOptions.filter((v) => v.setupId === data.setup_Prompt).map((val) => { return val.setupDescription; })[0];
                data.setup_Option = _billOfMaterialsSetupOptionDescription;
                _billOfMaterials.push(data);
                setBillOfMaterials(_billOfMaterials);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Bill of Materials Created', life: 3000 });
                setBillOfMaterial(emptyBillOfMaterial);
                _billOfMaterials.sort(function (a, b) { return (a.sequence as number) - (b.sequence as number) });
                dtBom.current.props.value = _billOfMaterials;
            });
        } else {
            BillOfMaterialService.updateBillOfMaterial(billOfMaterialData).then((data) => {
                if (data) {
                    let index = _billOfMaterials.findIndex(v => v.id === billOfMaterialData.id);
                    _billOfMaterials[index] = billOfMaterialData;
                    setBillOfMaterials(_billOfMaterials);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Bill of Materials Updated', life: 3000 });
                    setBillOfMaterial(emptyBillOfMaterial);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Bill of Materials', life: 3000 });
                }
            });
        }
    }

    const confirmDeleteBillOfMaterial = (billOfMaterial: BillOfMaterial) => {
        setBillOfMaterial(billOfMaterial);
        setDeleteBillOfMaterialDialog(true);
    }

    const deleteBillOfMaterial = (e: SyntheticEvent) => {
        BillOfMaterialService.deleteBillOfMaterial(billOfMaterial.id).then((data) => {
            if (data) {
                let _billOfMaterials = billOfMaterials.filter(val => val.id !== billOfMaterial.id);
                setBillOfMaterials(_billOfMaterials);
                formEditBillOfMaterials.reset(e);

                setDeleteBillOfMaterialDialog(false);
                setBillOfMaterial(emptyBillOfMaterial);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Bill of Material Deleted', life: 3000 });
            } else {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Delete Bill of Material', life: 3000 });
            }
        });
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'setup_Option':
                return setupOptionEditor(options);

            case 'usage_Code':
                return usageCodeEditor(options);

            case 'qty':
                return qtyEditor(options);

            case 'raw_Material_Group':
                return rawMaterialGroupDescriptionEditor(options);

            case 'setup_Prompt_For_Color':
                return colorSequenceReferenceEditor(options);

            case 'default_Color':
                return defaultColorEditor(options);

            case 'sublimation':
                return sublimationEditor(options);
        }
    }

    const setupOptionEditor = (options: any) => {
        return (
            <Controller
                name="setupOptionEdit"
                control={formEditBillOfMaterials.control}
                defaultValue={options.rowData.setup_Prompt}
                render={({ field, fieldState }) => {
                    billOfMaterial.setup_Prompt = field.value;

                    return (
                        <>
                            <Dropdown ref={ddSetupOption} value={fieldState.isDirty ? field.value : options.rowData.setup_Prompt} options={billOfMaterialsSetupOptions} optionLabel="setupDescription" optionValue="setupId" className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { billOfMaterial.setup_Prompt = e.value; field.onChange(e.value); }} filter filterBy="setupDescription" placeholder="Setup Option" virtualScrollerOptions={{ itemSize: 50 }} />
                        </>
                    )
                }
                }
            />
        );
    }

    const usageCodeEditor = (options: any) => {
        return (
            <Controller
                name="usageCodeEdit"
                control={formEditBillOfMaterials.control}
                defaultValue={options.value}
                rules={{
                    validate: {
                        isNumeric: v => ((!isNaN(parseInt(v, 10)) && isFinite(v)) || (v === null || v === undefined || v === '')) || 'Must be numeric or empty.',
                        zeroOrExists: v => ((parseInt(v, 10) === 0 || materialUsages.filter((val) => val.usage_Code === parseInt(v, 10)).length > 0) || (v === null || v === undefined || v === '')) || 'Must be 0 or existing Usage Code.',
                    }
                }}
                render={({ field, fieldState }) => {
                    billOfMaterial.usage_Code = field.value === '0' ? undefined : parseInt(field.value, 10);

                    return (
                        <>
                            <Dropdown
                                ref={ddUsageCode}
                                value={fieldState.isDirty ? (field.value === null) ? '0' : field.value : (options.value === null) ? '0' : options.value}
                                options={materialUsages}
                                optionLabel="usage_Code"
                                optionValue="usage_Code"
                                tooltip={fieldState.error?.message}
                                tooltipOptions={{ position: 'bottom' }}
                                className={classNames({ 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    billOfMaterial.usage_Code = e.value;
                                    field.onChange(e.value === undefined ? 0 : e.value);
                                    
                                    if (e.value !== undefined) {
                                        MaterialUsageService.getMaterialUsage(e.value).then(data => {
                                            let _billOfMaterials = [...billOfMaterials];
                                            let _billOfMaterial = _billOfMaterials.filter(val => val.id === options.rowData.id)[0];
                                            _billOfMaterial.qty = (data.usage as number);
                                            billOfMaterial.qty = (data.usage as number);
                                            setBillOfMaterials(_billOfMaterials);
                                        });
                                    }
                                }}
                                showClear
                                filter
                                filterBy="usage_Code"
                                placeholder="Usage Code"
                                virtualScrollerOptions={{ itemSize: 50 }} />
                        </>
                    )
                }
                }
            />
        );
    }

    const qtyEditor = (options: any) => {
        return (
            <>
                <span>{quantity}</span>
            </>
        );
    }

    const rawMaterialGroupDescriptionEditor = (options: any) => {
        return (
            <>
                <span>{rawMaterialGroupDescription}</span>
            </>
        );
    }

    const colorSequenceReferenceEditor = (options: any) => {
        return (
            <Controller
                name="colorSequenceReferenceEdit"
                control={formEditBillOfMaterials.control}
                defaultValue={options.value}
                rules={{
                    validate: {
                        notSelf: v => parseInt(v, 10) !== options.rowData.sequence || 'Sequence cannot reference itself.',
                        emptyOrExists: v => (v === undefined || v === null || v === '' || v === 0) || billOfMaterials.filter((val) => val.sequence === parseInt(v, 10)).length > 0 || 'Invalid Sequence.'
                    }
                }}
                render={({ field, fieldState }) => {
                    billOfMaterial.setup_Prompt_For_Color = field.value;

                    return (
                        <>
                            <InputNumber id={field.name} name={field.name} inputRef={field.ref} value={fieldState.isDirty ? field.value : options.value === 0 ? null : options.value} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} onBlur={field.onBlur} onValueChange={(e) => { field.onChange(e) }} placeholder="Color Seq #" />
                        </>
                    )
                }
                }
            />
        );
    }

    const defaultColorEditor = (options: any) => {
        return (
            <Controller
                name="defaultColorEdit"
                control={formEditBillOfMaterials.control}
                defaultValue={options.value}
                rules={{
                    validate: {
                        emptyOrExists: v => (v === null || v === undefined || v === '') || (setupOptionsColors.filter((val) => val.colorCode === v).length > 0) || 'Must be empty or existing Color.',
                    }
                }}
                render={({ field, fieldState }) => {
                    billOfMaterial.default_Color = field.value === null ? undefined : field.value;

                    if (!fieldState.isDirty) {
                        getSetupColorDescription(ddDefaultColor.current?.props.value);
                    }

                    return (
                        <>
                            <Dropdown
                                ref={ddDefaultColor}
                                value={fieldState.isDirty ? field.value : options.value}
                                options={setupOptionsColors}
                                optionLabel="colorCode"
                                optionValue="colorCode"
                                tooltip={fieldState.error ? fieldState.error?.message : setupColorDescription}
                                tooltipOptions={{ position: 'bottom' }}
                                className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })}
                                onChange={(e) => {
                                    billOfMaterial.default_Color = e.value;
                                    field.onChange(e.value === undefined ? '' : e.value);

                                    if (e.value === undefined) {
                                        setSetupColorDescription(undefined);
                                    }
                                    
                                    getSetupColorDescription(e.value);                                    
                                }}
                                editable
                                showClear
                                filter
                                filterBy="colorCode"
                                placeholder="Default Color"
                                virtualScrollerOptions={{ itemSize: 50 }} />
                        </>
                    )
                }
                }
            />
        );
    }

    const sublimationEditor = (options: any) => {
        return (
            <Controller 
                name="sublimationEdit" 
                control={formEditBillOfMaterials.control} 
                defaultValue={options.value}
                render={({ field, fieldState }) => {
                    billOfMaterial.sublimation = field.value;

                    return (
                        <>
                            <Checkbox ref={chkSublimation} inputId={field.name} checked={fieldState.isDirty ? field.value : options.value} inputRef={field.ref} className={classNames({ 'p-invalid mr-1': fieldState.error })} onChange={(e) => { billOfMaterial.sublimation = e.target.value; field.onChange(e.checked) }} />
                        </>
                    )}
                }
            />
        );
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const setBillOfMaterialsActiveRowIndex = (rowData: DataTableSelectionSingleChangeEvent<BillOfMaterial[]>) => {
        let selectedBillOfMaterialsIndex = billOfMaterials.findIndex(v => v.id === (rowData.value as BillOfMaterial).id);
        let _editingRows = { ...editingRows, ...{ [`${billOfMaterials[selectedBillOfMaterialsIndex].id}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }
        
    const sequenceBodyTemplate = (rowData: BillOfMaterial) => {
        return rowData.sequence;
    }

    const setupOptionBodyTemplate = (rowData: BillOfMaterial) => {
        let _billOfMaterialsSetupOptions = [...billOfMaterialsSetupOptions];
        let _billOfMaterialsSetupOptionDescription = _billOfMaterialsSetupOptions.filter((v) => v.setupId === rowData.setup_Prompt).map((val) => { return val.setupDescription; })[0];

        return _billOfMaterialsSetupOptionDescription;
    }

    const usageCodeBodyTemplate = (rowData: BillOfMaterial) => {
        return rowData.usage_Code ? rowData.usage_Code : 0;
    }

    const qtyBodyTemplate = (rowData: BillOfMaterial) => {
        let _materialUsages = [...materialUsages];
        let _materialUsage = _materialUsages.find((v) => { return v.usage_Code === rowData.usage_Code });

        return rowData.usage_Code === 0 ? 0 : _materialUsage?.usage;
    }

    const rawMaterialGroupBodyTemplate = (rowData: BillOfMaterial) => {
        let _rawMaterialGroups = [...rawMaterialGroups];
        let _rawMaterialGroupDescription = _rawMaterialGroups.filter((v) => v.id === rowData.raw_Material_Group).map((val) => { return val.raw_Material_Group + ' - ' + val.description; })[0];

        return (rowData.raw_Material_Group === null || rowData.raw_Material_Group === 0) ? 'NA' : rowData.rmgIsExcluded ? (<span className="text-red-500">{`${_rawMaterialGroupDescription}`}</span>) : _rawMaterialGroupDescription;
    }

    const setupPromptForColorBodyTemplate = (rowData: BillOfMaterial) => {
        return rowData.setup_Prompt_For_Color === 0 ? undefined : rowData.setup_Prompt_For_Color;
    }

    const defaultColorBodyTemplate = (rowData: BillOfMaterial) => {
        return rowData.default_Color;
    }

    const sublimationBodyTemplate = (rowData: BillOfMaterial) => {
        if (rowData.sublimation) {
            return (
                <>
                    <i className="pi pi-check text-green-500"></i>
                </>
            );
        } else {
            return (
                <>
                    <i className="pi pi-times text-red-500"></i>
                </>
            );
        }
    }

    const rowEditorBillOfMaterialsTemplate = (rowData: BillOfMaterial, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEditBillOfMaterials.getFieldState("setupOptionEdit").invalid && !formEditBillOfMaterials.getFieldState("usageCodeEdit").invalid && !formEditBillOfMaterials.getFieldState("colorSequenceReferenceEdit").invalid && !formEditBillOfMaterials.getFieldState("defaultColorEdit").invalid) {
                            let _billOfMaterial = { ...billOfMaterial };
                            _billOfMaterial.id = rowData.id;
                            _billOfMaterial.style_Code = rowData.style_Code;
                            _billOfMaterial.sequence = rowData.sequence;
                            _billOfMaterial.setup_Prompt = ddSetupOption.current?.props.value;
                            _billOfMaterial.usage_Code = ddUsageCode.current?.props.value;

                            let _materialUsages = [...materialUsages];
                            let selectedRawMaterialGroup = _materialUsages.filter((val) => val.usage_Code === _billOfMaterial.usage_Code).map((val) => { return val.raw_Material_Group; })[0]
                            _billOfMaterial.raw_Material_Group = selectedRawMaterialGroup ?? 0;
                            _billOfMaterial.default_Color = ddDefaultColor.current?.props.value;
                            _billOfMaterial.sublimation = chkSublimation.current.props.checked;                            
                            saveBillOfMaterial(_billOfMaterial);
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEditBillOfMaterials.clearErrors();
                        formEditBillOfMaterials.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            if (rowData.sequence !== undefined && rowData.sequence > 50) {
                return (
                    <>
                        <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDeleteBillOfMaterial(rowData)} to={''}></Link>
                    </>
                );
            }
        }
    }

    const deleteBillOfMaterialDialogFooter = (
        <>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteBillOfMaterialDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={(e) => deleteBillOfMaterial(e)} />
        </>
    );

    const copyDetailingPrompts = () => {
        if (!styleCode) { return; }

        BillOfMaterialService.copyDetailingPrompts(styleCode).then(bom => {
            setBillOfMaterials(bom);
            setLoadingStyleBillOfMaterials(false);
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const headerBillOfMaterials = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <Button label="Copy Detailing Prompts" icon="pi pi-copy" size="small" severity="success" outlined onClick={copyDetailingPrompts} />
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );
    
    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <Toast ref={toast} />

                <Panel header="Add Sequence" className="addPanel mb-2 -ml-2">
                    <form key={1} onSubmit={handleSubmitBillOfMaterials(onSubmitBillOfMaterials)} className="p-fluid" autoComplete="off">
                        <div className="formgrid grid">
                            <div className="field col-2">
                                <Controller
                                    name="setupOption"
                                    control={controlBillOfMaterials}
                                    rules={{
                                        required: 'Setup Option is required.'
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Setup Option</label>
                                            <Dropdown inputId={field.name} value={field.value} options={billOfMaterialsSetupOptions} optionLabel="setupDescription" optionValue="setupId" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { getBillOfMaterialSetupOptionDescription(e.value); field.onChange(e.value); }} showClear filter filterBy="setupDescription" placeholder="Setup Option" virtualScrollerOptions={{ itemSize: 50 }} />
                                            {(field.value !== null && field.value !== undefined && field.value !== '') ? <small className="text-primary">{billOfMaterialSetupOptionDescription}</small> : <></>}
                                            {getBillOfMaterialsErrorMessage('setupOption')}
                                        </>
                                    )}
                                />
                            </div>
                            <div className="field col-2">
                                <Controller
                                    name="usageCode"
                                    control={controlBillOfMaterials}
                                    rules={{
                                        validate: {
                                            isNumeric: v => ((!isNaN(parseInt(v, 10)) && isFinite(v)) || (v === null || v === undefined || v === '')) || 'Must be numeric or empty.',
                                            zeroOrExists: v => ((parseInt(v, 10) === 0 || materialUsages.filter((val) => val.usage_Code === parseInt(v, 10)).length > 0) || (v === null || v === undefined || v === '')) || 'Must be 0 or existing Usage Code.',
                                        }
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Usage Code</label>
                                            <Dropdown inputId={field.name} value={field.value} options={materialUsages} optionLabel="usage_Code" optionValue="usage_Code" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { getNewRawMaterialGroupDescription(e.value); field.onChange(e.value); triggerBillOfMaterials("usageCode"); }} editable showClear filter filterBy="usage_Code" placeholder="Usage Code" virtualScrollerOptions={{ itemSize: 50 }} />
                                            {(field.value !== null && field.value !== undefined && field.value !== '') ? <small className="text-primary">{newRawMaterialGroupDescription}</small> : <></>}
                                            {getBillOfMaterialsErrorMessage('usageCode')}
                                        </>
                                    )}
                                />
                            </div>
                            <div className="field col-2">
                                <Controller
                                    name="colorSequenceReference"
                                    control={controlBillOfMaterials}
                                    rules={{
                                        validate: {
                                            emptyOrExists: v => (v === undefined || v === null || v === '' || v === 0) || (billOfMaterials.length > 0 && billOfMaterials.filter((val) => val.sequence === parseInt(v, 10)).length > 0) || 'Invalid Sequence.'
                                            
                                        }
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Color Seq #</label>
                                            <InputNumber id={field.name} name={field.name} inputRef={field.ref} value={fieldState.isDirty ? field.value : field.value === '' ? null : field.value} inputClassName={classNames({ 'p-invalid border-left-10': fieldState.error })} onBlur={field.onBlur} onChange={(e) => { field.onChange(e.value); triggerBillOfMaterials("colorSequenceReference"); }} placeholder="Color Seq #" />
                                            {getBillOfMaterialsErrorMessage('colorSequenceReference')}
                                        </>
                                    )}
                                />
                            </div>
                            <div className="field col-2">
                                <Controller
                                    name="defaultColor"
                                    control={controlBillOfMaterials}
                                    rules={{
                                        validate: {
                                            emptyOrExists: v => (v === null || v === undefined || v === '') || (setupOptionsColors.filter((val) => val.colorCode === v).length > 0) || 'Must be empty or existing Color.',
                                        }
                                    }}
                                    render={({ field, fieldState }) => (
                                        <>
                                            <label htmlFor={field.name} className="font-bold text-xs">Default Color</label>
                                            <Dropdown inputId={field.name} value={field.value} options={setupOptionsColors} optionLabel="colorCode" optionValue="colorCode" className={classNames('w-full', { 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { getSetupColorDescription(e.value); field.onChange(e.value); triggerBillOfMaterials("defaultColor"); }} editable showClear filter filterBy="colorCode" placeholder="Default Color" virtualScrollerOptions={{ itemSize: 50 }} />
                                            {(field.value !== null && field.value !== undefined && field.value !== '') ? <small className="text-primary">{setupColorDescription}</small> : <></>}
                                            {getBillOfMaterialsErrorMessage('defaultColor')}
                                        </>
                                    )}
                                />
                            </div>
                            <div className="field col-fixed isCheckbox">
                                    <Controller
                                        name="sublimation"
                                        control={controlBillOfMaterials}
                                        render={({ field, fieldState }) => (
                                            <>
                                                <label htmlFor={field.name} className="font-bold text-xs">Sublimation</label><br />
                                                <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames('col-offset-4', { 'p-invalid mr-1': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                                            </>
                                        )}
                                    />
                                </div>
                            <div className="field field-buttons col-2 pt-4">
                                <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                                <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={resetBillOfMaterials} />
                            </div>
                        </div>
                    </form>
                </Panel>

                <DataTable ref={dtBom} className="-ml-2" value={billOfMaterials} selectionMode="single" onSelectionChange={setBillOfMaterialsActiveRowIndex}
                    dataKey="id" size="small" rowHover={true} loading={loadingStyleBillOfMaterials}
                    sortField="sequence" sortOrder={1}
                    editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange}
                    filters={filters} globalFilterFields={['sequence', 'setup_Option', 'usage_Code', 'qty', 'rmgDescription', 'setup_Prompt_For_Color', 'default_Color']}
                    emptyMessage="No bill of materials found." header={headerBillOfMaterials}>
                    <Column field="sequence" header="Sequence" body={sequenceBodyTemplate} sortable align="center" alignHeader="center"></Column>
                    <Column field="setup_Option" header="Setup Option" body={setupOptionBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} sortable align="center" alignHeader="center"></Column>
                    <Column field="usage_Code" header="Usage Code" body={usageCodeBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} sortable align="center" alignHeader="center"></Column>
                    <Column field="qty" header="Qty" body={qtyBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} sortable align="center" alignHeader="center"></Column>
                    <Column field="raw_Material_Group" header="Raw Material Group" body={rawMaterialGroupBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} sortable align="center" alignHeader="center"></Column>
                    <Column field="rmgDescription" style={{'display': 'none'}} header="Raw Material Group"></Column>
                    <Column field="setup_Prompt_For_Color" header="Color Sequence Ref" body={setupPromptForColorBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} sortable align="center" alignHeader="center"></Column>
                    <Column field="default_Color" header="Default Color" body={defaultColorBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} sortable align="center" alignHeader="center"></Column>
                    <Column field="sublimation" header="Sublimation" body={sublimationBodyTemplate} editor={(options: ColumnEditorOptions) => cellEditor(options)} sortable align="center" alignHeader="center"></Column>
                    <Column rowEditor body={rowEditorBillOfMaterialsTemplate} bodyStyle={{ textAlign: 'center', minWidth: '8rem' }}></Column>
                </DataTable>

                <Dialog visible={deleteBillOfMaterialDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteBillOfMaterialDialogFooter} onHide={hideDeleteBillOfMaterialDialog}>
                    <div className="flex align-items-center justify-content-center">
                        <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                        {billOfMaterial && <span>Are you sure you want to delete Sequence <b>{billOfMaterial.sequence}</b>?</span>}
                    </div>
                </Dialog>
            </div>
        </div>
    );
};

export default StyleBillOfMaterials;